import React from 'react';

const Form = (props) => {
    const setFieldHandler = event => {
        props.setField(event.target.name, event.target.value);
    }

    const keyPressHandler = (event) => {
        if (event.key === 'Enter') {
            props.login(props.history);
        }
    }

    const handleSignIn = () => {
        props.login(props.history);
    }

    return (
        <div className="login-container">
            <div className="logo-container">
                <img src="https://sc-eps.s3.amazonaws.com/logo.png" alt="EPS" />
            </div>
            <div className="sign-container">
                <div className="sign-in-container">
                    <h1>Login</h1>
                    <div className="fields">
                        <div className="field">
                            <div className="icon"><i className="fa-solid fa-user"></i></div>
                            <input type="text" name="email" value={props.form.email} onChange={setFieldHandler} onKeyPress={keyPressHandler} placeholder="Email" />
                        </div>
                        <div className="field">
                            <div className="icon"><i className="fa-solid fa-key"></i></div>
                            <input type="password" name="password" value={props.form.password} onChange={setFieldHandler} onKeyPress={keyPressHandler} placeholder="Password" />
                        </div>
                    </div>
                    <div className="text-center">
                        <button type="button" onClick={handleSignIn} disabled={props.isLogging}>{props.isLogging ? <i className="fas fa-circle-notch fa-spin"></i> : 'Sign In'}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Form;
